export enum StorageKeys {
  session = 'c2Vzc2lvblN0b3JhZ2U=',
}
